import { render } from "./InvoiceList.vue?vue&type=template&id=173b4332&ts=true"
import script from "./InvoiceList.vue?vue&type=script&lang=ts"
export * from "./InvoiceList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__